import { httpClient } from '@/shared/services';
import type { ClientOption, Configuration, Result, Source } from './types';
export const batchTemplatesService = {
  async categories(clientId: string): Promise<{ id: string; name: string }[]> {
    return (await httpClient.get<{ categories: { id: string; name: string }[] }>('/v1/batch-templates/categories', { params: { clientId } })).data.categories;
  },
  async clients(): Promise<ClientOption[]> {
    return (await httpClient.get<{ clients: ClientOption[] }>('/v1/batch-templates/clients')).data.clients;
  },
  async link(sku: string, locale: string, version: string): Promise<string> {
    return (await httpClient.post<{ url: string }>('/v1/batch-templates/link', { sku, locale, version })).data.url;
  },
  async sources(baseSku: string, locale: string) {
    const response = await httpClient.post<{ candidates: Source[] }>('/v1/batch-templates/source', { baseSku, locale });
    return response.data.candidates;
  },
  async row(action: 'preview' | 'execute', config: Configuration, sku: string, modelId?: string): Promise<Result> {
    const { version: _version, ...body } = config;
    const response = await httpClient.post<{ results: Result[] }>(`/v1/batch-templates/${action}`, {
      ...body, targets: [{ sku, ...(modelId ? { modelId } : {}) }],
    });
    if (!response.data.results?.[0]) throw new Error('No se recibió el resultado. Consulta las fichas antes de reintentar.');
    return response.data.results[0];
  },
};
